import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "alignY", "spacing", "className", "children"];
import "core-js/modules/es6.array.map.js";
import React from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import classes from '@nerdwallet/base-styles/classes';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';
import { useNegativeMarginTop, useNegativeMarginLeft } from '../hooks/useNegativeMargin';

var getJustifyContent = function getJustifyContent(align) {
  switch (align) {
    case 'left':
      return 'flex-start';

    case 'center':
      return 'center';

    case 'right':
      return 'flex-end';

    default:
      return undefined;
  }
};

export var getAlignItems = function getAlignItems(alignY) {
  switch (alignY) {
    case 'top':
      return 'flex-start';

    case 'center':
      return 'center';

    case 'bottom':
      return 'flex-end';

    default:
      return undefined;
  }
};
/**
 * Simple flexbox container that adds a set amount
 * of horizontal space between each of its children.
 */

export var Cluster = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$alignY = _ref.alignY,
      alignY = _ref$alignY === void 0 ? 'top' : _ref$alignY,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 3 : _ref$spacing,
      className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedClassNameStylePropsWarning('Cluster', {
    className: className
  });
  var flattenedChildren = flattenChildren(children);
  var marginTop = useNegativeMarginTop(spacing);
  var marginLeft = useNegativeMarginLeft(spacing);
  return /*#__PURE__*/React.createElement(Box, _extends({
    "data-currency": "Cluster",
    display: "flex",
    flexWrap: "wrap",
    alignItems: getAlignItems(alignY),
    justifyContent: getJustifyContent(align),
    className: [className, marginTop, marginLeft],
    ref: ref
  }, otherProps), flattenedChildren.map(function (child, index) {
    // Don't render falsy children.
    if (!child) return null;
    return /*#__PURE__*/React.createElement(Box, {
      marginLeft: spacing,
      marginTop: spacing,
      className: classes('max-width-100') // Default to child.key to enable users to opt in to keyed
      // children. Since the `React.ReactChild` type includes the
      // `string` type, we need to cast the child to `any` to avoid a
      // TypeScript error.
      ,
      key: child.key || index
    }, child);
  }));
});
Cluster.displayName = 'Cluster';